module.exports = __webpack_public_path__ + "img/triangle.0c53ff7c.svg";